export { ConfirmButton, ConfirmButton as default } from './confirm-button';
